import { Loader, Box } from '@hawkins/components';

interface Props {
  width?: string;
  height?: string;
}

export const AppLoader = ({ width, height }: Props) => (
  <Box
    width={width}
    height={height}
    display="flex"
    alignItems="center"
    justifyContent="center"
  >
    <Loader />
  </Box>
);
